import { connect } from 'react-redux';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import { sendPageviewAction } from 'src/store/analytics/actions';
import { setVariant } from 'src/store/reviews/slice';
import {
  getCashbackLabel,
  getCashbackLabelBackgroundColor,
  getCashbackLabelTextColor,
  getCashbackTooltip,
  getCashbackIconWebp,
  getCashbackIconPng,
  getActivateCashbackForPartner,
} from 'src/store/cashback/selectors';
import { getHasReviewsSection } from 'src/store/reviews/selectors';
import { showPageAction } from '../../store/actions/view';
import {
  getHotelCurrentPage,
  getIsWhitelabel,
} from '../../store/selectors/view';
import { getSearchParamsForUrl } from '../../store/selectors/searchParams';

import {
  getCashbackForCheapestRoom,
  getCashbackTypeForCheapestRoom,
} from '../../store/selectors/rooms';
import LayoutMobile from './LayoutMobile';
import { getHotelRoulette, getLinkedHotels } from '../../store/hotel';
import { getIsShowHotelFAQ } from '../../store/hotel/selectors';

const mapStateToProps = (state) => ({
  page: getHotelCurrentPage(state),
  isRoulette: getHotelRoulette(state),
  linkedHotels: getLinkedHotels(state),
  searchParams: getSearchParamsForUrl(state),
  isWhitelabel: getIsWhitelabel(state),
  cashbackCount: getCashbackForCheapestRoom(state),
  cashbackType: getCashbackTypeForCheapestRoom(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
  labelColor: getCashbackLabelBackgroundColor(state),
  textColor: getCashbackLabelTextColor(state),
  cashbackTooltipText: getCashbackTooltip(state),
  cashbackLabel: getCashbackLabel(state),
  cashbackIconWebp: getCashbackIconWebp(state),
  cashbackIconPng: getCashbackIconPng(state),
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  hasReviewsSection: getHasReviewsSection(state),
  isShowHotelFAQ: getIsShowHotelFAQ(state),
});

const mapDispatchToProps = {
  showPage: showPageAction,
  sendPageview: sendPageviewAction,
  setVariantReviews: setVariant,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutMobile);
